// Sotto questa soglia la slide del video esce dalla rotazione: il video non parte sui
// dispositivi piccoli e non c'e' piu' un'immagine di ripiego che lo sostituisca. Il valore
// deve restare allineato alla media query in hero-slideshow.liquid.
const MOBILE_QUERY = '(max-width: 640px)';

class OmtHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.hero');
    this.slides = Array.from(this.section.querySelectorAll('.slide'));
    this.copies = Array.from(this.section.querySelectorAll('.sc'));
    this.dots = Array.from(this.section.querySelectorAll('.dot-b'));
    this.nav = this.section.querySelector('.hero-nav');
    if (this.slides.length < 2) return;

    this.index = 0;
    this.mobile = window.matchMedia(MOBILE_QUERY);
    this.syncOrder();
    this.mobile.addEventListener('change', () => this.syncOrder());

    this.section.querySelector('[data-omt-hero-prev]')?.addEventListener('click', () => this.step(-1));
    this.section.querySelector('[data-omt-hero-next]')?.addEventListener('click', () => this.step(1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
  }

  // Ricalcola quali slide partecipano alla rotazione al viewport corrente e nasconde le altre
  // insieme al loro testo e al loro pallino, cosi' non restano comandi che puntano al vuoto.
  syncOrder() {
    const skipVideo = this.mobile.matches;
    this.order = this.slides
      .map((slide, i) => (skipVideo && slide.hasAttribute('data-video-slide') ? -1 : i))
      .filter((i) => i >= 0);
    // Tutte le slide sono video: meglio mostrarle che lasciare l'hero vuoto.
    if (!this.order.length) this.order = this.slides.map((_, i) => i);

    this.slides.forEach((slide, i) => {
      const off = !this.order.includes(i);
      slide.classList.toggle('is-off', off);
      this.copies[i]?.classList.toggle('is-off', off);
      this.dots[i]?.classList.toggle('is-off', off);
    });
    this.nav?.classList.toggle('is-off', this.order.length < 2);

    this.go(this.order.includes(this.index) ? this.index : this.order[0]);
  }

  step(delta) {
    const pos = this.order.indexOf(this.index);
    this.go(this.order[(pos + delta + this.order.length) % this.order.length]);
  }

  go(next) {
    if (!this.order.includes(next)) return;
    this.index = next;
    this.slides.forEach((slide, i) => {
      const isCurrent = i === this.index;
      slide.classList.toggle('on', isCurrent);
      // Le slide non attive restano nel flusso con opacity:0 (visibility resta visible per la
      // transizione), quindi senza questo toggle un eventuale testo alternativo di TUTTE le
      // slide verrebbe annunciato insieme. Lo stato iniziale lo imposta il Liquid.
      slide.setAttribute('aria-hidden', String(!isCurrent));
    });
    this.copies.forEach((copy, i) => copy.classList.toggle('on', i === this.index));
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('on', i === this.index);
      dot.setAttribute('aria-pressed', String(i === this.index));
    });
  }
}
customElements.define('omt-hero-slideshow', OmtHeroSlideshow);
